import React from 'react'
import { Card, Button } from 'react-bootstrap'

const HomePageOption = (props) => {
  const {
    image,
    title,
    description,
    buttonText,
    imageVariant,
    buttonVariant,
  } = props


  return (
    <Card className='HomePageOption'>

      <Card.Img
        className="home-page-option-image"
        variant={imageVariant}
        src={image}
        onClick={props.onClick}
      />

      <Card.Body className='center-text'>
        <Card.Title>
          {title}
        </Card.Title>

        <Card.Text>
          {description}
        </Card.Text>

      </Card.Body>

      <Card.Footer bg='light'>
        <Button
          className='center'
          variant={buttonVariant}
          onClick={props.onClick}
        >
          {buttonText}
        </Button>
      </Card.Footer>
    </Card>
  )
}

HomePageOption.defaultProps = {
  imageVariant: 'top',
  buttonVariant: 'primary',
}

export default HomePageOption
